import * as gzQuickFilter from './quick-filter.filter';

export default angular.module('gazelle.components.filterBox.quickFilter', [
])
  .filter(gzQuickFilter.name, gzQuickFilter.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/filter-box/quick-filter/quick-filter.module.js